import { render, staticRenderFns } from "./ModalGenerateBalance.vue?vue&type=template&id=2ec68956&scoped=true&"
import script from "./ModalGenerateBalance.vue?vue&type=script&lang=js&"
export * from "./ModalGenerateBalance.vue?vue&type=script&lang=js&"
import style0 from "./ModalGenerateBalance.vue?vue&type=style&index=0&id=2ec68956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec68956",
  null
  
)

export default component.exports